import * as React from 'react';

import { AnalyticsStore } from 'bernie-core';

import { mapProperty } from 'src/common/stores/adapters';
import { PropertyListingProvider } from 'src/common/stores/contexts/propertyListing/property-listing-provider';

import { ResultType } from 'constants/resultType';

import { Listing } from './listing';
import { ListTitle } from 'components/search/listing/list-title';
import { MessagingCard } from 'components/common/messaging-card/messaging-card';
import { OverfilteredMessagingCard } from '../common/messaging-card/overfiltered-messaging-card';
import { StaticMultiItemCrossSellWrapper } from 'components/multi-item/static-lodging-multi-item-cross-sell-wrapper';

export interface ResultProps {
  analytics?: AnalyticsStore;
  className: string;
  endDate: string;
  index: number;
  lazyLoadImg: boolean;
  loading: boolean;
  model: any;
  resultType: ResultType;
  startDate: string;
  setResultRef?: (ref: HTMLElement, index: number) => void;
  stidKey?: string;
  type?: string;
  lazyLoad?: boolean;
}

export const Result = (props: ResultProps) => {
  const { model, resultType, ...rest } = props;

  switch (resultType) {
    case ResultType.MESSAGING:
      if (model?.type === 'OVERFILTERED') {
        return <OverfilteredMessagingCard model={model} {...rest} />;
      }

      return <MessagingCard model={model} {...rest} />;
    case ResultType.FREE_CANCELLATION:
      return <MessagingCard model={model} {...rest} />;
    case ResultType.LIST_TITLE:
      return <ListTitle model={model} resultType={resultType} {...rest} />;
    case ResultType.STATIC_LODGING_MULTI_ITEM_CROSS_SELL:
      return <StaticMultiItemCrossSellWrapper model={model} resultType={resultType} {...rest} />;
    case ResultType.HOTEL:
    default:
      return (
        <PropertyListingProvider propertyListing={model}>
          <Listing model={mapProperty(model)} {...rest} />
        </PropertyListingProvider>
      );
  }
};
